// extracted by mini-css-extract-plugin
export default {"pricing-page":"PricingPage_pricing-page__qAPuq"};